import { DdpImage } from "@/components/shared/DdpImage"
import { TDdpMedia } from "@/shared/types"

export function SecondSection(props: Array<{
    description: string
    title: string
    labelUnderLogo: string
    logo: Array<TDdpMedia>
}>) {
    const { description, title, labelUnderLogo, logo } = props[0]
    return (
        <div className="landing-second-section">
            <div className="content-wrapper">
                <DdpImage className="logo" image={logo[0]} />
                <div className="label-under-logo">{labelUnderLogo}</div>
                <div className="title">{title}</div>
                <div className="description" dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        </div>
    );
}
